export enum AvailableEmpresaFilters {
    Frecuencias = "frecuencias",
    TiposVisita = "tiposVisita",
    Estados = "estados",
    TiposEmpresa = "tiposEmpresa",
    Municipios = "municipios",
    Turnos = "turnos",
    Prospectadores = "prospectadores",
}

export enum Turnos {
    Matutino = 1,
    Vespertino = 2,
    Nocturno = 3,
}

export enum SendReminderTimes {
    OneHour = "1 hora antes",
    OneDay = "1 día antes",
    OneWeek = "1 semana antes",
}

export enum ROLES {
    ADMIN = "Administrador",
    PROSP = "Prospectador",
}